import type { HeaderContext } from './header.types'

import { createContext } from '../utils'

const [HeaderProvider, useHeaderContext] = createContext<HeaderContext>({ isOptional: true })

export { HeaderProvider, useHeaderContext }
